import { Symbole } from '@/components/ui/Symbole';
import { cn } from '@/lib/cn';

type ThumbProps = {
  num: string;
  /** Durée de la vidéo en minutes ; absente pour un épisode à venir. */
  minutes?: number;
  /** Épisode annoncé : vignette en pointillés, sans lecture. */
  todo?: boolean;
  /** Grand lecteur de la page série : bouton centré, plus gros. */
  large?: boolean;
};

/**
 * Vignette vidéo : emplacement en attendant les lecteurs intégrés
 * (maquette, « À brancher »).
 */
export function Thumb({ num, minutes, todo = false, large = false }: ThumbProps) {
  return (
    <div
      className={cn(
        'relative flex aspect-video items-center justify-center overflow-hidden',
        large ? 'rounded-xl' : 'rounded-md',
        todo ? 'border border-dashed border-encre/25 bg-blanc text-encre/25' : 'bg-encre text-blanc',
      )}
    >
      <span className={cn('label absolute top-3.5 left-3.5 font-medium', todo ? 'text-encre-mute' : 'text-ciel')}>
        Épisode {num}
      </span>
      <Symbole
        accent={todo ? 'var(--color-line)' : undefined}
        className={cn('aspect-square h-auto', large ? 'w-[16%]' : 'w-[20%]')}
      />
      {!todo && minutes !== undefined && (
        <span className="absolute bottom-3 left-3 rounded-xs bg-blanc/14 px-2 py-1.5 text-label leading-none font-medium tabular-nums">
          {minutes} min
        </span>
      )}
      {!todo && (
        <span
          aria-hidden="true"
          className={cn(
            'absolute flex items-center justify-center rounded-full bg-ciel transition-transform',
            large
              ? 'top-1/2 left-1/2 size-19 -translate-1/2 group-hover:scale-106'
              : 'right-3.5 bottom-3.5 size-13 group-hover:scale-108',
          )}
        >
          <span
            className={cn(
              'ml-1 border-y-transparent border-l-encre',
              large ? 'border-y-[13px] border-l-[22px]' : 'border-y-[9px] border-l-[15px]',
            )}
          />
        </span>
      )}
    </div>
  );
}
